import type { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunity/typings'
import type { Dispatch, SetStateAction } from 'react'
import type { ILeadOppProduct } from '@user/store/leadOppProducts'
import type { IOpportunityIsCloseableModel } from '@user/store/opportunity/typings'

import { useEffect } from 'react'

type Props = {
  values: IAddOpportunityFormModel
  setOpportunity: Dispatch<
    SetStateAction<IOpportunityIsCloseableModel | undefined>
  >
  services: ILeadOppProduct[]
}

export function useManageOpportunityData(props: Props) {
  const { values, setOpportunity, services } = props

  useEffect(() => {
    if (values.salesFunnelId) {
      setOpportunity({
        externalLinkId: values.billToExternalLinkId ?? '',
        leadId:
          values.sourceEntityId && values.sourceEntityId !== -1
            ? values.sourceEntityId
            : null,
        opportunityId: values.opportunityId || null,
        products: services,
        salesFunnelId: values.salesFunnelId,
      })
    }
  }, [
    services,
    setOpportunity,
    values.billToExternalLinkId,
    values.salesFunnelId,
    values.sourceEntityId,
  ])
}
